/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pricingtickets1Inputs */

const en_pricingtickets1 = /** @type {(inputs: Pricingtickets1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pricing & Tickets`)
};

const de_pricingtickets1 = /** @type {(inputs: Pricingtickets1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Preise & Tickets`)
};

/**
* | output |
* | --- |
* | "Pricing & Tickets" |
*
* @param {Pricingtickets1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const pricingtickets1 = /** @type {((inputs?: Pricingtickets1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pricingtickets1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pricingtickets1(inputs)
	return de_pricingtickets1(inputs)
});
export { pricingtickets1 as "pricingTickets" }